import { i18n } from '../../i18n/i18n';
import { DataService } from '../../services/data_service';
import { LinkedinResponse } from './share-certificate.model';

/**
 * Client for sharing certificates.
 */
export class LuaShareCertificateClient {
  private dataService: DataService;

  /**
   * Creates an instance of LuaShareCertificate and initializes the data service.
   */
  constructor() {
    this.dataService = DataService.getInstance('');
  }

  /**
   * Shares the certificate on LinkedIn for the given enrollment ID.
   * Fetches the LinkedIn share URL from the backend and opens it in a new tab.
   * If an error occurs, displays an error toast notification to the user.
   *
   * @param enrollmentId - The unique identifier for the enrollment to share
   */
  public async shareOnLinkedIn(enrollmentId: number) {
    try {
      const data = await this.dataService.get<LinkedinResponse>(
        `/angie/content-details/share-certificate/${enrollmentId}`
      );
      window.open(data.linkedin_core_url, '_blank');
    } catch (error) {
      window.LuAnywhere.services.toast.getInstance().showToast({
        message: i18n('lua.share-certificate.error_to_share', { platform: 'LinkedIn' }),
        variant: 'error',
      });
    }
  }
}
